import React from "react";
import {
  BooleanField,
  ReferenceInput,
  SelectInput,
  List,
  Datagrid,
  TextField,
  Filter,
  TextInput
} from "react-admin";
import { formatName, parseName } from "../util/misc";

const SeasonTeamFilter = (props) => {
  return (
    <Filter {...props}>
      <TextInput
        label="School Name"
        source="name"
        format={(v) => (v ? formatName(v) : "")}
        parse={(v) => (v ? parseName(v) : "")}
        alwaysOn
      />
      <ReferenceInput
        label="Season"
        source="seasonCode"
        reference="availableSeasons"
        alwaysOn
      >
        <SelectInput optionText="label" optionValue="code" />
      </ReferenceInput>
      <ReferenceInput
        label="Sport"
        source="sportCode"
        reference="sportCodes"
        alwaysOn
      >
        <SelectInput optionText="label" optionValue="code" />
      </ReferenceInput>
    </Filter>
  );
};

const SeasonTeamList = (props) => (
  <List
    {...props}
    bulkActionButtons={false}
    filters={<SeasonTeamFilter />}
    actions={null}
  >
    <Datagrid rowClick="edit">
      <TextField source="id" />
      <TextField source="team.school.name" />
      <TextField source="sportCode" />
      <TextField source="seasonCode" />
      <TextField source="district.label" />
      <BooleanField source="isInArea" />
    </Datagrid>
  </List>
);

export default SeasonTeamList;
